<script>
import { mapState } from 'vuex';
import PickupPointsMap from "./PickupPointsMap.vue";

export default {
    props: ['contacts'],
    components: {PickupPointsMap},
    data() {
        return {
            locationContacts: [],
        }
    },
    computed: {
        ...mapState('geo', [
            'location',
        ]),
    },
    methods: {
        phoneNumberFormat (number) {
            number = number.replace(/[^0-9]/gm, '');
            console.log(number);

            return '7' + number.substring(1, 11);
        }
    },
    watch: {
        location (val) {
            if (val) {
                let _this = this;
                let current = val ? this.contacts.find(contact => parseInt(val.city.id) === parseInt(contact.city_id)) : false,
                    contact = [];

                if (!current) {
                    current = '7700000000000';
                } else {
                    current = current.city_id;
                }

                [current, '5500000100000'].forEach(function (cityId) {
                    let city = _this.contacts.find(contact => parseInt(cityId) === parseInt(contact.city_id));

                    if (city) {
                        contact.push(city);
                    }
                });
                this.locationContacts = contact;
            }
        }
    }
}
</script>
<template>
    <div>
        <div class="about-contacts page-header-sub row no-gutters mb-4">
            <div v-for="contact in locationContacts" :key="`contact-${contact.city_id}`"
                 class="col-sm-5 mt-3">
                <h3>г. {{ contact.name }}</h3>
                <div class="about-contacts-address mt-4">
                    <span class="icon location-filled"></span>
                    <div>
                        <span>Адрес:</span>
                        <span>{{ contact.address }}</span>
                    </div>
                </div>
                <div class="about-contacts-phone">
                    <span class="icon phone"></span>
                    <div>
                        <span>Телефон:</span>
                        <span>
                            <a v-for="(number,index) in contact.phone_numbers"
                               :key="`number-${index}`"
                               :href="`tel:+${phoneNumberFormat(number)}`">{{ number }}</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <pickup-points-map />
        <contact-us />
    </div>
</template>
